export default __webpack_public_path__ + "static-bigflip/media/deed-of-establishment.3797c1b4.png";